const auth = {
  email: 'Correo electrónico',
  password: 'Contraseña',
  welcomeMessage: 'Inicie sesión en su cuenta',

  validations: {
    email: {
      required: 'El correo electrónico es obligatorio',
      email: 'Dirección de correo electrónico no válida',
      emailReceived: 'La dirección de correo electrónico que recibió de su administrador',
    },
    password: {
      required: 'Se requiere contraseña',
      password: 'Contraseña no válida',
    },
    otp: {
      required: 'Se requiere un código de 6 dígitos.',
      invalid: 'El código que insertó no es válido.'
    }
  },
  resetPassword: {
    email: 'Falta el correo electrónico',
    resetToken: 'El token de restablecimiento no es válido',
  },
  loginBtn: 'Iniciar sesión',
  toast: {
    authFailed: 'El correo electrónico o la contraseña no son válidos',
    unexpectedError: 'Ocurrió un error inesperado',
    codeInvalid: 'La verificación falló. Asegúrese de haber ingresado el código de 6 dígitos correcto o solicite uno nuevo.',
    securityUpdate: 'Se actualizaron las políticas de seguridad. Lamentamos las molestias.',
  },

  toastBlockRequest: {
    body: 'Ha sido bloqueado temporalmente debido a demasiados intentos fallidos. Intente de nuevo más tarde',
  },

  /** 2FA related translations below */
  twoFactorAuthSelectMessage: 'Elija el método de verificación',
  twoFactorAuthVerifyMessage: 'Verificar este dispositivo',
  twoFactorAuthVerifyLabel: 'Introduzca el código de 6 dígitos que le acabamos de enviar.',
  sendVerificationCodeBtn: 'Enviar Código de Verificación',
  phoneMethodLabel: 'Sms',
  verifyBtn: 'Enviar',
  resendVerificationCodeBtn: 'Reenviar código',
  resendVerificationCodeLbl: 'Reenviar código en {{seconds}} s ...',
};

export default auth;
